(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["stella-header"] && !Shopify.designMode) return;
  try {
    (() => {
    const updateNavigation = () => {
      const header = document.querySelector('.stella-header[data-diners-context]');
      if (!header) return;
      const key = 'stella-diners-navigation';
      let active = header.dataset.dinersContext === 'true';
      if (!active && header.dataset.dinersContinuation === 'true') {
        try {
          const started = Number(sessionStorage.getItem(key));
          active = started > 0 && Date.now() - started < 30 * 60 * 1000;
        } catch {}
        if (!active && document.referrer) {
          try {
            const source = new URL(document.referrer);
            active = (['the-stella.com', 'www.the-stella.com'].includes(source.hostname)
              && /^\/diners202610(?:\/vol1)?\/?$/.test(source.pathname))
              || (source.origin === location.origin && /^\/pages\/diners202610\/?$/.test(source.pathname));
          } catch {}
        }
      }
      try {
        if (active) sessionStorage.setItem(key, String(Date.now()));
        else sessionStorage.removeItem(key);
      } catch {}
      document.querySelectorAll('[data-stella-nav]').forEach(link => {
        link.href = active ? link.dataset.dinersHref : link.dataset.defaultHref;
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateNavigation, { once: true });
    else updateNavigation();
    window.addEventListener('pageshow', updateNavigation);
  })();
  } catch(e) { console.error(e); }
})();

})();
